import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { hasExternalDeliveryProviders } from '../../services/tenant/serviceProviderConfig';
import { isPlgOnboardingProvider } from '../../services/tenant/plgOnboarding';

export default function useServiceProvider() {
  const { serviceProvider } = useSelector((state) => state.currentServiceProvider);

  const hasExternalDelivery = useMemo(
    () => hasExternalDeliveryProviders(serviceProvider?.regional_config?.supported_delivery_providers),
    [serviceProvider?.regional_config?.supported_delivery_providers],
  );

  const hasExternalAnalytics = !!serviceProvider?.has_analytics_provider;

  // Self-serve (PLG) partner onboarding: FoodAmigos-only and not-yet-applicable
  // surfaces are hidden. See services/tenant/plgOnboarding.js.
  const hasPlgOnboarding = isPlgOnboardingProvider(serviceProvider);

  return {
    hasExternalDelivery,
    hasExternalAnalytics,
    hasPlgOnboarding,
  };
}
